import bem from '../../../utils/bem';
import ChangeLogTablesList from '../../ChangeLog/ChangeLogTablesList';
import { ToggleSection } from '../../ToggleSection';
import NotificationLogTitle from '../NotificationLogTitle/NotificationLogTitle';
import type { NotificationsLogListEntryProps } from '../types';

const NotificationsLogListEntry = ({
  audits,
  toggles = [],
  toggleAt,
  originalIndex,
  dateFormat,
  toggleCheckedAt,
  checkedIds,
  id,
}: NotificationsLogListEntryProps): JSX.Element => {
  const [block] = bem('notification-log-list-entry');

  const isExpanded = Array.isArray(toggles[originalIndex])
    ? (toggles[originalIndex] as boolean[])[0]
    : (toggles[originalIndex] as boolean);

  const title = <NotificationLogTitle id={id} formattedDate={dateFormat} />;

  const action = (
    <div>
      <input
        type="checkbox"
        checked={checkedIds.includes(id)}
        onChange={(e) => {
          e.stopPropagation();
          toggleCheckedAt(id, e.target.checked);
        }}
      />
    </div>
  );

  return (
    <div className={block()} data-testid="notification-log-list-entry">
      <ToggleSection
        title={title}
        action={action}
        isExpanded={isExpanded}
        handleToggle={(e): void => {
          e.stopPropagation();
          toggleAt(originalIndex, toggles[originalIndex]);
        }}
        key={`notification-toggle-${originalIndex}`}
      >
        <ChangeLogTablesList tablesProps={audits?.tablesProps} toggles={toggles} index={originalIndex} />
      </ToggleSection>
    </div>
  );
};

export default NotificationsLogListEntry;
